import { CallbackComponent, userManager } from 'helpers/authentication'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

const authReturnUrl = localStorage.getItem('authReturnUrl')

const AuthenticationContainer = ({ router: { navigate } }) => {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() =>
        authReturnUrl ? (window.location.href = authReturnUrl) : navigate('/')
      }
      errorCallback={(error) => {
        navigate('/')
        console.error(error)
      }}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  )
}

AuthenticationContainer.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
  }).isRequired,
}

export default connect()(withRouter(AuthenticationContainer))
